import React, { useEffect } from "react";
import { InputField } from "../../../lib";
import styled from "@emotion/styled";
import { useFormikContext } from "formik";
import { FieldsContainer } from "src/styles/Containers";

function AddCallsToActionFields() {
  const formikProps = useFormikContext();
  const [focus, setFocus] = React.useState(true);

  useEffect(() => {
    if (formikProps) formikProps.setTouched({});

    setFocus(false);
  }, []);

  return (
    <FieldsContainer>
      <InputField
        placeholder={"Add Call to Action"}
        name={"name"}
        inputRef={(input: any) => (focus ? input && input.focus() : null)}
        onFocus={(e: any) => {
          e.currentTarget.setSelectionRange(
            e.currentTarget.value.length,
            e.currentTarget.value.length
          );
        }}
      />
    </FieldsContainer>
  );
}

export default AddCallsToActionFields;
